import {
  Box,
  Button,
  Container,
  Flex,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import ActionMenu from '@v2/commons/components/ActionMenu/ActionMenu.component'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'

import { IUpdateClinicForm } from '../../clinics.type'
import { openClinicDeleteModal } from '../DeleteUserModal/DeleteUserModal.component'
import classes from './clinic-information.module.scss'

interface UserInformationProps {
  onSubmit: () => void
  editForm: boolean
  setEditForm: (values: boolean) => void
  handleCancelForm: () => void
  loading: boolean
  clinicId: string
  clinicInformationForm: UseFormReturnType<IUpdateClinicForm>
}

const ClinicInformation = ({
  onSubmit,
  editForm,
  setEditForm,
  handleCancelForm,
  clinicInformationForm,
  loading,
  clinicId,
}: UserInformationProps) => {
  return (
    <Box my="md">
      <Flex
        justify="space-between"
        align="flex-start"
        className={classes.headerWrapper}
      >
        <Text fw={700} c="blue.5">
          Clinic Information
        </Text>
        <ActionMenu
          menuItems={[
            {
              label: 'Update',
              color: 'blue',
              icon: <Icons.Edit />,
              onClick: () => setEditForm(true),
              enable: true,
            },
            {
              label: 'Delete',
              color: 'red',
              icon: <Icons.Trash />,
              onClick: () => openClinicDeleteModal(clinicId),
              enable: true,
            },
          ]}
        />
      </Flex>
      <Flex justify="center">
        <Container mx="md" className={classes.flex1} my="lg">
          <form
            onSubmit={(e) => {
              e.preventDefault()
              onSubmit()
            }}
          >
            <SimpleGrid cols={2} spacing="xl" verticalSpacing="xl">
              <Select
                key={clinicInformationForm.key('program')}
                label="Clinic Type"
                placeholder="Select Clinic Type"
                data={[
                  { label: 'Dental', value: 'DENTAL' },
                  { label: 'Vision', value: 'VISION' },
                ]}
                withAsterisk
                disabled={!editForm}
                {...clinicInformationForm.getInputProps('program')}
              />
              <TextInput
                key={clinicInformationForm.key('name')}
                label="Clinic Name"
                withAsterisk
                disabled={!editForm}
                {...clinicInformationForm.getInputProps('name')}
              />
            </SimpleGrid>
            {editForm && (
              <Flex justify="space-between" align="flex-start" mt="lg">
                <Button onClick={() => handleCancelForm()} variant="outline">
                  Cancel
                </Button>
                <Button loading={loading} type="submit" variant="filled">
                  Save
                </Button>
              </Flex>
            )}
          </form>
        </Container>
      </Flex>
    </Box>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  ClinicInformation,
  'is_enable_leads_table',
  true,
)
